export class User {
  id: string = ''
  firstName: string = ''
  lastName: string = ''
  email: string = ''
  activated: boolean = false
  
  public nameStr() { return this.firstName +' '+ this.lastName }
}
